!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.emailMask = t() : e.emailMask = t();
}(this, function () {
  return function (e) {
    function t(r) {
      if (n[r]) return n[r].exports;
      var u = n[r] = {
        exports: {},
        id: r,
        loaded: !1
      };
      return e[r].call(u.exports, u, u.exports, t), u.loaded = !0, u.exports;
    }

    var n = {};
    return t.m = e, t.c = n, t.p = "", t(0);
  }([function (e, t, n) {
    e.exports = n(3);
  },,, function (e, t, n) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    function u(e, t) {
      e = e.replace(y, h);
      var n = t.placeholderChar,
          r = t.currentCaretPosition,
          u = e.indexOf(x),
          s = e.lastIndexOf(d),
          f = s < u ? -1 : s,
          p = o(e, u + 1, x),
          g = o(e, f - 1, d),
          v = c(e, u, n),
          m = i(e, u, f, n),
          O = a(e, f, n, r);
      v = l(v), m = l(m), O = l(O, !0);
      var b = v.concat(p).concat(m).concat(g).concat(O);
      return b;
    }

    function o(e, t, n) {
      var r = [];
      return e[t] === n ? r.push(n) : r.push(g, n), r.push(g), r;
    }

    function c(e, t) {
      return t === -1 ? e : e.slice(0, t);
    }

    function i(e, t, n, r) {
      var u = h;
      return t !== -1 && (u = n === -1 ? e.slice(t + 1, e.length) : e.slice(t + 1, n)), u = u.replace(new RegExp("[\\s" + r + "]", m), h), u === x ? p : u.length < 1 ? v : u[u.length - 1] === d ? u.slice(0, u.length - 1) : u;
    }

    function a(e, t, n, r) {
      var u = h;
      return t !== -1 && (u = e.slice(t + 1, e.length)), u = u.replace(new RegExp("[\\s" + n + ".]", m), h), 0 === u.length ? e[t - 1] === d && r !== e.length ? p : h : u;
    }

    function l(e, t) {
      return e.split(h).map(function (e) {
        return e === v ? e : t ? b : O;
      });
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = n(4),
        f = r(s),
        p = "*",
        d = ".",
        h = "",
        x = "@",
        g = "[]",
        v = " ",
        m = "g",
        O = /[^\s]/,
        b = /[^.\s]/,
        y = /\s/g;
    t["default"] = {
      mask: u,
      pipe: f["default"]
    };
  }, function (e, t) {
    "use strict";

    function n(e, t) {
      var n = t.currentCaretPosition,
          o = t.rawValue,
          p = t.previousConformedValue,
          d = t.placeholderChar,
          h = e;
      h = r(h);
      var x = h.indexOf(i),
          g = null === o.match(new RegExp("[^@\\s." + d + "]"));
      if (g) return c;
      if (h.indexOf(l) !== -1 || x !== -1 && n !== x + 1 || o.indexOf(u) === -1 && p !== c && o.indexOf(a) !== -1) return !1;
      var v = h.indexOf(u),
          m = h.slice(v + 1, h.length);
      return (m.match(f) || s).length > 1 && h.substr(-1) === a && n !== o.length && (h = h.slice(0, h.length - 1)), h;
    }

    function r(e) {
      var t = 0;
      return e.replace(o, function () {
        return t++, 1 === t ? u : c;
      });
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t["default"] = n;
    var u = "@",
        o = /@/g,
        c = "",
        i = "@.",
        a = ".",
        l = "..",
        s = [],
        f = /\./g;
  }]);
});